import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AuthService } from './access/auth.service';
import { ModalService } from './util/modal.service';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'demo-express';
  $data: Subscription;
  modalData = '';
  static isBrowser = new BehaviorSubject<boolean>(false);
  constructor(private _auth: AuthService, private _modalService: ModalService,@Inject(PLATFORM_ID) private platformId: any ){
    AppComponent.isBrowser.next(isPlatformBrowser(platformId));
    this._auth.checkToken()
    this.$data = this._modalService.data$.subscribe(data => {
      this.modalData = data
    })

  }
}
